export default "__VITE_ASSET__Dt5V5RYq__"